'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('@fancyapps/fancybox');

require('../sections/hamburger.js');

require('../sections/cartflyout.js');

require('../templates/collection_myo_grid.js');

require('../templates/collection_myo_list.js');

require('../templates/subscription_add.js');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _operators = require('rxjs/operators');

// Common a11y fixes


// Custom Make Your Own pages


// Custom Hamburger Menu
(0, _themeA11y.focusHash)();

// Hamburger Menu

// Custom Cart Flyout


// Fancybox

(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}